export default {
    BIG_BANK: 'bigBank',
    BRAND: 'brand',
    BROKERAGE: 'brokerage',
    LENDER: 'lender',
};